module.exports = __webpack_public_path__ + "static/media/filter.e2c4ebef.svg";